import React from 'react'
import {Button} from 'ui'
import {useTranslations} from "../hooks/use-translations"

interface Props {
  id?: number;
  onClose: () => void;
  onSubmit: () => void;
}

export default function CouponDrawerFooter ({ id, onClose, onSubmit }: Props) {
  const t = useTranslations()

  return (
    <div className="footer">
      <Button label={t('general.cancel')} onClick={onClose}/>
      <Button
        label={t(id ? 'general.submit' : 'general.add')}
        type="primary"
        htmlType="submit"
        onClick={onSubmit}
      />
    </div>
  )
}